<template>
    <div v-if="$store.state.connected" class="deconnection">
        <h1>Déconnexion</h1>
    </div>
</template>

<script>
    import router from "../router/index.js";

    export default {
        name: "deconnection",
        created: function() {
            this.$store.commit('clearConnected');
            router.push('connexion');
        }
    };
</script>